<div class="login_page">
  <div class="container-fluid">
    <div class="login-wrapper row">
      <div id="login" class="login loginpage col-md-3 offset-3">
        <h1><a title="Login Page" tabindex="-1">Portal Admin</a></h1>


        <form name="loginform" id="loginform" [formGroup]="loginForm" (ngSubmit)="login(loginForm.value)" autocomplete="off">
          @if(errorMessage) {
            <div class="label-danger row message">
              <label> {{errorMessage}}</label>
            </div>
          }

          <p>
            <label for="userName">
              Username<br />
              <input type="text" formControlName="userName" id="userName" class="input" name="userName" size="20" />
              @if(loginForm.controls.userName.invalid&&loginForm.controls.userName.touched) {
                <em class="text-danger">Required</em> 
              }
            </label>
          </p>

          <p>
            <label for="pwd">
              Password<br />
              <input type="password" id="pwd" autocomplete="off" class="input" formControlName="password" name="password" size="20" />
              @if(loginForm.controls.password.invalid&&loginForm.controls.password.touched) {
                <em class="text-danger">Required</em>
              }

            </label>
          </p>


          <p class="submit">
            <input type="submit" name="submit" id="submit" class="btn btn-accent btn-block" [disabled]="!loginForm.valid" value="Sign In" />
          </p>

        </form>
        <p>
          <a class="pull-left" routerLink="/password-reset">Forgotten password?</a>
        </p>

      </div>
    </div>
  </div>
</div>
